import React from "react";
import {Grid, Box, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import ResponsiveDialog from "../../widget/dialog/ResponsiveDialog";
import CustomAlert from "../alerts/CustomAlert";

const ActionCardsDialog = ({isOpen, onClose, logo, title, description, cards, displayError, errorComponent, alertClassName, reverseCardsOrder, reduceMargins, ...props}) => {

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={onClose}
            content={(
                <Box
                    mb={reduceMargins ? 5 : 10}
                >
                    <Box
                        textAlign="center"
                    >
                        {logo}
                        <Box
                            mt={reduceMargins ? 0 : 5}
                        >
                            <Typography
                                variant={"h3"}
                                align={"center"}
                            >
                                {title}
                            </Typography>
                        </Box>
                        {description}
                        {displayError && (
                            <Box
                                mt={reduceMargins ? 1 : 2}
                                mb={reduceMargins ? 2.5 : 5}
                                display="flex"
                                justifyContent="center"
                            >
                                <CustomAlert
                                    className={alertClassName}
                                    type={"error"}
                                    noTypeText
                                >
                                    {errorComponent}
                                </CustomAlert>
                            </Box>
                        )}

                    </Box>
                    <Grid
                        container
                        spacing={2}
                        justify="center"
                        direction={reverseCardsOrder ? "row-reverse" : "row"}
                    >
                        {cards?.map((card, index) => {
                            return (
                                <Grid
                                    item
                                    key={index}
                                >
                                    {card}
                                </Grid>
                            );
                        })}
                    </Grid>
                </Box>
            )}
            {...props}
        />
    );
};

ActionCardsDialog.propTypes = {
    isOpen: PropTypes.bool,
    displayError: PropTypes.bool,
    errorComponent: PropTypes.any,
    alertClassName: PropTypes.any,
    onClose: PropTypes.func,
    logo: PropTypes.any,
    title: PropTypes.string,
    description: PropTypes.any,
    cards: PropTypes.arrayOf(PropTypes.element),
    reverseCardsOrder: PropTypes.bool,
    reduceMargins: PropTypes.bool
};


export default ActionCardsDialog;
